import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { installStaleChunkReload } from './shared/lib/staleChunkReload';
import { hydrateCompany } from './shared/companyBoot';

import './styles/fonts.css';
import './styles/tokens.css';
import './styles/reset.css';
import './App.css';
import './styles/motion.css';
// Last on purpose: the Quotinc-family interface re-values tokens and chrome
// under <html data-skin="quotinc"> and must win ties with everything above.
import './styles/skin-quotinc.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found.');

// Recover automatically when a deploy has replaced the chunks this tab still
// remembers. Installed BEFORE render so a lazy route that fails on first
// navigation is already covered.
installStaleChunkReload();

// The tenant's company profile (Admin ▸ Company) lands BEFORE the first
// paint, so the login page, the guest pages and the shell never show the
// build's name and then the saved one. Bounded wait; on any failure the
// build profile paints (shared/companyBoot.ts).
void hydrateCompany().finally(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
